"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/objectWithoutProperties"));
var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/taggedTemplateLiteral"));
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _Grid = _interopRequireDefault(require("@mui/material/Grid"));
var _Heading = _interopRequireDefault(require("../../elements/Heading/Heading"));
var _Link = _interopRequireDefault(require("../../elements/Link/Link"));
var _HorizontalDivider = _interopRequireDefault(require("../../elements/horizontal-divider/Horizontal-Divider"));
var _bfBaseStyles = require("@bestfit-team/bf-base-styles");
var _PageGrid = _interopRequireDefault(require("../../layouts/Skeletons/PageGrid/PageGrid"));
var _TeamCard = _interopRequireDefault(require("../../organisms/TeamCard/TeamCard.js"));
var _ThreeColumnLayout = _interopRequireDefault(require("../../layouts/ThreeColumnLayout/ThreeColumnLayout"));
var _TwoColumnLayout = _interopRequireDefault(require("../../layouts/TwoColumnLayout/TwoColumnLayout"));
var _excluded = ["heading", "founderCards", "employeeCards"];
var _templateObject, _templateObject2;
var StyledHeading = (0, _styledComponents.default)(function (_ref) {
  var className = _ref.className,
    children = _ref.children;
  return _react.default.createElement(_Heading.default, {
    h2: true,
    pink: true,
    className: className
  }, " ", children, " ");
})(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2.default)(["\n    text-align: center;\n    margin-bottom: 5rem;\n  "])));
var StyledPageGrid = (0, _styledComponents.default)(_PageGrid.default)(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteral2.default)(["\n  background-color: var(--bf-core-white);\n  text-align: center;\n  border-top: transparent;\n  border-bottom: transparent;\n  border-left: transparent;\n  border-left-width: 0px !important;\n  border-right: transparent;\n  border-right-width: 0px !important;\n  border-width: thick;\n  border-style: solid;\n  padding-top: 25px;\n  padding-bottom: 25px;\n"])));
var OurTeam = function OurTeam(_ref2) {
  var heading = _ref2.heading,
    founderCards = _ref2.founderCards,
    employeeCards = _ref2.employeeCards,
    props = (0, _objectWithoutProperties2.default)(_ref2, _excluded);
  return _react.default.createElement(StyledPageGrid, {
    justifyContent: "center"
  }, _react.default.createElement(StyledHeading, null, heading), _react.default.createElement(_Grid.default, {
    container: true,
    justifyContent: "center"
  }, _react.default.createElement(_TwoColumnLayout.default, Object.assign({
    variant: "SixSixRatio",
    justifyContent: "space-around"
  }, props), founderCards.map(function (card) {
    return _react.default.createElement(_Grid.default, {
      item: true,
      xs: 10,
      sm: 7,
      md: 4.5,
      lg: 4,
      xl: 4
    }, _react.default.createElement(_TeamCard.default, {
      card: card
    }));
  })), _react.default.createElement(_ThreeColumnLayout.default, {
    justifyContent: "space-around"
  }, employeeCards.map(function (card) {
    return _react.default.createElement(_Grid.default, {
      item: true,
      xs: 10,
      sm: 6,
      md: 4,
      lg: 4,
      xl: 4
    }, _react.default.createElement(_TeamCard.default, {
      card: card
    }));
  }))));
};
var _default = OurTeam;
exports.default = _default;